export default __webpack_public_path__ + "img/supplier.ac13be1b.svg";